/**
 * The icons a landing page author can choose, stored by name on the page. A
 * name that is not in the set (an older page, a typo) falls back to a neutral
 * icon instead of breaking the page.
 */
import { Link } from 'lucide-react'
import { LANDING_ICONS } from '@/services/landing/landingIcons'

export function LandingIcon({ name, size = 16, className, fallback = 'link' }: { name?: string | null; size?: number; className?: string; fallback?: string }) {
  const Icon = (name && LANDING_ICONS[name]) || LANDING_ICONS[fallback] || Link
  return <Icon size={size} className={className} aria-hidden="true" />
}
